// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 12px !important;
}

.shipping-shell {
  min-width: 620px;
  max-width: 100%;
}

.shipping-subtitle {
  margin: 0 0 12px;
  color: #526072;
}

.shipping-form {
  display: grid;
  gap: 12px;
}

.shipping-card {
  border: 1px solid #d9e1ea;
  border-radius: 10px;
  padding: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.ship-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-weight: 600;
}

.ship-grid {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 8px 12px;
  margin-top: 12px;
  align-items: center;
}

.ship-grid-short {
  max-width: 420px;
}

.field-error {
  margin: 8px 0 0;
  color: #b42318;
  font-size: 0.85rem;
}

.general-error {
  margin: 0 0 12px;
  color: #b42318;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.actions-spacer {
  flex: 1 1 auto;
}

@media (max-width: 768px) {
  .shipping-shell {
    min-width: auto;
  }
  .ship-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/shipping-information/shipping-information-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,6DAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;EAEA;IACE,0BAAA;EAAF;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 12px !important;\n}\n\n.shipping-shell {\n  min-width: 620px;\n  max-width: 100%;\n}\n\n.shipping-subtitle {\n  margin: 0 0 12px;\n  color: #526072;\n}\n\n.shipping-form {\n  display: grid;\n  gap: 12px;\n}\n\n.shipping-card {\n  border: 1px solid #d9e1ea;\n  border-radius: 10px;\n  padding: 12px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.ship-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-weight: 600;\n}\n\n.ship-grid {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 8px 12px;\n  margin-top: 12px;\n  align-items: center;\n}\n\n.ship-grid-short {\n  max-width: 420px;\n}\n\n.field-error {\n  margin: 8px 0 0;\n  color: #b42318;\n  font-size: 0.85rem;\n}\n\n.general-error {\n  margin: 0 0 12px;\n  color: #b42318;\n}\n\n.loading-wrap {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.actions-spacer {\n  flex: 1 1 auto;\n}\n\n@media (max-width: 768px) {\n  .shipping-shell {\n    min-width: auto;\n  }\n\n  .ship-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
